import React from 'react'
import PropTypes from 'prop-types'

const CHECK_PATH = 'M6.36667 10.1L12.0167 4.45C12.15 4.31667 12.3056 4.25 12.4833 4.25C12.6611 4.25 12.8167 '
  + '4.31667 12.95 4.45C13.0833 4.58333 13.15 4.74167 13.15 4.925C13.15 5.10833 13.0833 5.26667 12.95 5.4'
  + 'L6.83333 11.5333C6.7 11.6667 6.54444 11.7333 6.36667 11.7333C6.18889 11.7333 6.03333 11.6667 5.9 '
  + '11.5333L3.03333 8.66667C2.9 8.53333 2.83611 8.375 2.84167 8.19167C2.84722 8.00833 2.91667 7.85 3.05 '
  + '7.71667C3.18333 7.58333 3.34167 7.51667 3.525 7.51667C3.70833 7.51667 3.86667 7.58333 4 7.71667'
  + 'L6.36667 10.1Z'

const THIN_CHECK_PATH = 'M8.93481 0.706055L3.49731 7.45605C3.3912 7.5877 3.23135 7.66461 3.06226 7.66553'
  + 'C2.89315 7.66641 2.73251 7.59099 2.625 7.46045L0 4.27295L0.868652 3.55811L3.0542 6.21167'
  + 'L8.05884 0L8.93481 0.706055Z'

const GLYPHS = {
  regular: { viewBox: '0 0 16 16', path: CHECK_PATH },
  thin: { viewBox: '-1.5348 -2.2716 12 12', path: THIN_CHECK_PATH }
}

const CheckIcon = ({ className = '', variant = 'regular' }) => {
  const { viewBox, path } = GLYPHS[variant]

  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="currentColor"
      height="1em"
      viewBox={viewBox}
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={path} />
    </svg>
  )
}

CheckIcon.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(GLYPHS))
}

CheckIcon.defaultProps = {
  className: '',
  variant: 'regular'
}

export default CheckIcon
